const featuresSection = document.querySelector(".features");

	const videoPlayer = document.querySelector(".video-player");
	const video = document.querySelector("video");
	const pauseBtn = document.querySelector(".video-player .controls__pause-btn");
	const muteBtn = document.querySelector(".video-player .controls__mute-btn");
	const timeline = document.querySelector(".video-player .controls__timeline");
	const progressBar = document.querySelector(".video-player .controls__timeline-progress");
	const cursor = document.querySelector(".follow-cursor");
	let x = 0;
	let y = 0;
	let showTimeout;
	let mouseStatusInterval;
	let showed = false;
	let targetControls = false;

	function cursorPosition(e) {
		x = e.clientX;
		y = e.clientY;
		e.target.closest(".video-player .controls") ? (targetControls = true) : (targetControls = false);
	}
	function playVideo() {
		mouseStatusInterval = setInterval(() => {
			if (x == 0 && y == 0) {
				// console.log("mouse stopped");
				if (!showed && !targetControls) {
					showTimeout = setTimeout(() => {
						cursor.classList.add("hidden");
						videoPlayer.classList.remove("is-idle");
					}, 1500);
					showed = true;
				}
			} else {
				// console.log("mouse moves");
				clearTimeout(showTimeout);
				cursor.classList.remove("hidden");
				videoPlayer.classList.add("is-idle");
				showed = false;
			}
			x = 0;
			y = 0;
		}, 100);

		videoPlayer?.classList.add("_active");
		video.play();
	}

	function stopVideo(e) {
		const target = e.target;
		if (target.closest(".controls")) return;
		video.pause();
		video.currentTime = 0;
		videoPlayer.classList.remove("_active");
		muteBtn.classList.remove("_active");
		video.muted = false;
		pauseBtn.classList.remove("_active");
		clearTimeout(showTimeout);
		clearTimeout(mouseStatusInterval);
		cursor.classList.remove("hidden");
	}

	function pauseVideo() {
		if (pauseBtn.classList.contains("_active")) {
			pauseBtn.classList.remove("_active");
			video.play();
		} else {
			pauseBtn.classList.add("_active");
			video.pause();
		}
	}

	function mutedVideo() {
		if (muteBtn.classList.contains("_active")) {
			muteBtn.classList.remove("_active");
			video.muted = false;
		} else {
			muteBtn.classList.add("_active");
			video.muted = true;
		}
	}

	function updateTime() {
		let percent = (video.currentTime / video.duration) * 100;
		progressBar.style.width = percent.toFixed(1) + "%";
	}

	function getPos(e) {
		const { left, width } = timeline.getBoundingClientRect();
		let percent = ((e.clientX - left) / width) * 100;
		let pos = (video.duration * percent) / 100;
		video.currentTime = pos;
	}

	let current = 0;
	function doScroll(e) {
		e = window.event || e;
		var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
		current = current + delta;
		if (delta == 1 && video.volume <= 0.9) {
			video.volume += 0.1;
		}
		if (delta == -1 && video.volume > 0.1) {
			video.volume -= 0.1;
		}
		// e.preventDefault();
		$("html").getNiceScroll().hide();
	}

	window.addEventListener(
		"resize",
		function () {
			if (document.documentElement.clientWidth > 992) {
				const featuresPlayBtn = document.querySelector(".features__play-btn");
				featuresPlayBtn.removeEventListener("click", playVideo);
				featuresSection.addEventListener("click", playVideo);
			} else {
				const featuresPlayBtn = document.querySelector(".features__play-btn");
				featuresSection.removeEventListener("click", playVideo);
				featuresPlayBtn.addEventListener("click", playVideo);
			}
		},
		true
	);
	muteBtn.addEventListener("click", mutedVideo, { passive: true });
	pauseBtn.addEventListener("click", pauseVideo, { passive: true });
	video.addEventListener("timeupdate", updateTime, { passive: true });
	video.addEventListener("ended", stopVideo, { passive: true });
	timeline.addEventListener("click", getPos, { passive: true });
	videoPlayer.addEventListener("click", stopVideo, { passive: true });
	videoPlayer.addEventListener("mousemove", cursorPosition, { passive: true });
	video.addEventListener("mousewheel", doScroll, { passive: true });

